<template>
  <div class="lby-tab-bar">
    <router-link to="/" exact>前往首页</router-link>
    <router-link to="/taskindex">任务中心</router-link>
    <router-link to="/gossipindex">瓜区入口</router-link>
    <div class="collapse-able">
      <router-link to="/gamedataindex">游戏资料</router-link>
      <div class="collapse-able-float">
        <div><router-link to="/crossserverindex">跨服线路</router-link></div>
        <div style="transform: translateY(2px);"><router-link to="/goodspriceindex">各区物价</router-link></div>
        <div style="transform: translateY(6px);"><router-link to="/recreationindex">影音娱乐</router-link></div>
      </div>
    </div>
    <div class="collapse-able">
      <router-link to="/msconsignmentindex">ms寄售</router-link>
      <div class="collapse-able-float">
        <div><router-link to="/equipmentindex">装备寄售</router-link></div>
      </div>
    </div>
    <router-link to="/rentindex">账号出租</router-link>
    <router-link to="/commercialindex">商会中心</router-link>
    <router-link to="/rankinglistindex">排行榜中心</router-link>
    <router-link to="/usercenter">个人中心</router-link>
    <router-link to="/cooperation">合作中心</router-link>
  </div>
</template>

<script>
export default {
  name: 'TabBar'
}
</script>

<style scoped lang="less">
.lby-tab-bar{
    height:35px;
    background: linear-gradient(to right, #312951, #2d7897, #8e56a2,#d9edf2);
    box-shadow: 0 0 2px #d3d3d3;
    font-size: 13px;
    a{
        display: inline-block;
        padding: 0 20px;
        margin-left: 10px;
        line-height: 35px;
        box-shadow: 1px 0 0 #ffffff;
        border-radius: 10px;
        color:rgb(253, 253, 253);
    }
    a:hover{
        text-decoration:none;
        font-size: 16px;
    }
    .router-link-active{
      font-size: 16px;
      color:#fc7615;
    }
    .collapse-able{
      display: inline-block;
      box-sizing: border-box;
      position: relative;
      .collapse-able-float{
        position: absolute;
        display: none;
        z-index: 1010;
        a{
          color:rgb(253, 253, 253);
          border-radius: 0;
          background: linear-gradient(to right, #3f7299, #4e6d9b);
          width: 70px;
          transform: translateX(-6px) translateY(2px);
          box-shadow: none;
        }
        .router-link-exact-active{
          font-size: 16px;
          color:#fc7615;
        }
      }
    }
    .collapse-able:hover{
        .collapse-able-float{
          display: block;
        }
        .collapse-able-float:hover{
          display: block;
        }
    }
}
</style>
